<template>
  <header class="hero is-dark is-bold">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">Arcanestats</h1>
        <h2 class="subtitle">
          Dice statistics for Warcaster: Neo-Mechanika
        </h2>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "ThePageHeader"
};
</script>

<style scoped></style>
